export const makeCursorResults = (list, body = {}) => {
  let parsed = body;
  if (typeof body === 'string') {
    try {
      parsed = JSON.parse(body);
    } catch {
      parsed = {};
    }
  }
  const limit = parsed.limit ?? 20;
  const cursor = parsed.cursor ?? null;
  const offset = cursor ? parseInt(atob(cursor), 10) : 0;

  const sliced = list.slice(offset, offset + limit);
  const nextOffset = offset + limit;
  const hasMore = nextOffset < list.length;

  return {
    results: sliced,
    nextCursor: hasMore ? btoa(String(nextOffset)) : null,
    hasMoreResults: hasMore,
  };
};

export const makeListResults = (
  list,
  searchParams,
  options = { listName: 'results' },
) => {
  const num = list.length;
  const p = Object.fromEntries(searchParams);

  const count = p.count == null ? num : parseInt(p.count);
  const page = p.page == null ? 0 : parseInt(p.page);

  const paging = {
    total: num,
    currentPage: page,
    count: Math.min(num, count),
    totalPages: num === 0 ? 0 : Math.floor(num / count) + 1,
  };

  return {
    paging,
    [options.listName]: list.slice(page * count, page * count + count),
  };
};
